// Add this line temporarily for debugging
// console.log('API URL:', process.env.REACT_APP_API_URL);

export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:1337/api/test',
  //  baseUrl: 'http://localhost:1337/api/test'
}; 